import { useContext } from 'react'
import { ViewSizeContext } from '../contexts'

export const useNarrowWidth = () => {
  const { narrowWidth } = useContext(ViewSizeContext)
  return narrowWidth
}
